// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"bc1c9e34dd90fe6e31b5","655":"b6b32bd51abfe7cbf897"}[chunkId] + ".js";
};